$(function () {
  var dropzone = $('.dragonDrop-dropzone');
  var documentDropZone = $('#footer_upload_section');
  var doc = $('body');

  doc.on('dragover', function (event) {
      event.preventDefault();
      event.stopPropagation();
      dropzone.addClass('dragover-doc');
  });

  doc.on('dragleave', function (event) {
      event.preventDefault();
      event.stopPropagation();
      dropzone.removeClass('dragover-doc');
  });

  doc.on('dragend', function (event) {
    event.preventDefault();
      event.stopPropagation();
      dropzone.removeClass('dragover-doc');
  });

  dropzone.on('dragover', function (e) {
    e.preventDefault || e.preventDefault();
    e.stopPropagation || e.stopPropagation();
    dropzone.addClass('dragover');

    return false;
  });

  dropzone.on('dragleave', function (e) {
    console.log(e);
    e.preventDefault || e.preventDefault();
    e.stopPropagation || e.stopPropagation();
    dropzone.removeClass('dragover');
    return false;
  });

  dropzone.on('drop', function (e) {
    e.preventDefault || e.preventDefault();
    e.stopPropagation || e.stopPropagation();

    // Close the 'Unsupported Filetype', if the user didn't close it before uploading another file
    $('.notification').hide();

    var file = e.originalEvent.dataTransfer.files[0];
    var myfile = file.name;
    var filename = myfile;
    var ext = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
    if (ext == 'jpg' || ext == 'jpeg' || ext == 'png' || ext == 'gif' || ext == 'bmp') {
      dropzone.removeClass('dragover dragover-doc');
      dropzone.html('');

      handleFileUpload(e.originalEvent.dataTransfer.files, dropzone);
    } else {
      unsupportedFile();
    }
    return false;
  });

  documentDropZone.on('drop', function (e) {
    e.preventDefault || e.preventDefault();
    e.stopPropagation || e.stopPropagation();
    handleDocumentFileUpload(e.originalEvent.dataTransfer.files, documentDropZone);
    return false;
  });

  dropzone.on('click', function () {
    $('input[name=dragonDrop-fileinput]').trigger('click');
  });

  $('body').on('change', '#image_upload', function (e) {
    e.preventDefault || e.preventDefault();
    e.stopPropagation || e.stopPropagation();

    // Close the 'Unsupported Filetype', if the user didn't close it before uploading another file
    $('.notification').hide();

    // Bug fix for Kaycan console issues -- does not need to run this code if not a drag and drop upload
    if (typeof e.currentTarget.files[0] === 'undefined') {
      return false;
    }

    var file = e.currentTarget.files[0];

    var myfile = file.name;
    var filename = myfile;
    var ext = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
    if (ext == 'jpg' || ext == 'jpeg' || ext == 'png' || ext == 'gif' || ext == 'bmp') {
      dropzone.removeClass('dragover dragover-doc');
      dropzone.html('');
      handleFileUpload(e.currentTarget.files);
    } else {
      unsupportedFile();
    }

    return false;
  });
});

function handleFileUpload(files, obj) {
  $('#loading').show();
  var fd = new FormData();

  fd.append('image_upload', files[0]);
  fd.append('client', Renoworks.client);
  sendFileToServer(fd, files);
}

function sendFileToServer(formData, files) {
  var uploadURL = 'Upload'; // Upload URL
  var extraData = {}; // Extra Data.
  var jqXHR = $.ajax({
    xhr: function () {
      var xhrobj = $.ajaxSettings.xhr();
      if (xhrobj.upload) {
        xhrobj.upload.addEventListener('progress', function (event) {
          var percent = 0;
          var position = event.loaded || event.position;
          var total = event.total;
          if (event.lengthComputable) {
            percent = Math.ceil(position / total * 100);
          }
        }, false);
      }
      return xhrobj;
    },
    url: uploadURL,
    type: 'POST',
    contentType: false,
    processData: false,
    cache: false,
    data: formData,
    success: function (data) {
      // $("#status1").append("File upload Done<br>");
          if (data.indexOf('ERROR') == -1) {
            var reader = new FileReader();

            reader.onload = function (e) {
              $('.dragonDrop-dropzone').css({ 'background-image': 'url(' + e.target.result + ')' });
            };

            reader.readAsDataURL(files[0]);
            $('#loading').hide();
            $('#upload_scene_btn').removeClass('disabled');
            Renoworks.upload = data;
            if (Renoworks.mobile) {
              $('#upload_scene_btn').click();
            }
          } else {
            unsupportedFile();
          }
    },
  });
}

function unsupportedFile() {
  var html = '<p style="text-align: center;">Only the following file-types are accepted:<br> jpg, jpeg, png and bmp.</p>';
  var title = '<div class="locale_html" data-locale-id="unsupported_filetype">' + Renoworks.LocaleController.getValueForKey('unsupported_filetype') + '</div>';
  var classes = 'notice';
  var buttons = [];
  var button = new Renoworks.Button();
  button.name = 'Ok';
  button.classes = 'btn';
  button.callback = function () {
    Renoworks.Notify.hide();
  };
  buttons.push(button);
  Renoworks.Notify.show(html, title, classes, buttons);

  // Clear the file input
  $('input[name=dragonDrop-fileinput]').parent()[0].reset();
}
